import { Action } from '@ngrx/store';
import { IBanner } from '@nx-ng/types';

export interface ApplicationState {
  banner: IBanner;
  gtmEnabled: boolean;
  actionsToRetry: Action[];
}
